import {endpoint} from "@/utils/api/Conf";
import {Path} from "@/types/Paths";
import {Segment} from "@/types/Segments";
import {Scan} from "@/types/Scan";

export const segmentRequest = async (segmentId: string, locale: string): Promise<Segment | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        "X-Language": locale || "it"
      }
    }
    return await fetch(endpoint + `segments/${segmentId}`, init)
      .then((response) => response.json())
      .then((data: Segment) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
}

export const segmentPlacesRequest = async (authToken: string, pathId: string): Promise<Path | false> => {
  if (!authToken) return false
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }
    return await fetch(endpoint + `segments/${pathId}/places`, init)
      .then((response) => response.json())
      .then((data: Path) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};

export const segmentAction = async (authToken: string, action: Scan): Promise<Segment | false> => {
  if (!authToken) return false
  try {
    const init: RequestInit = {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify({actions: [action]})
    }
    return await fetch(endpoint + `walk/action`, init)
      .then((response) => response.json())
      .then((data: Segment) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
}
